import {
  RESET_ARCHITECTURE,
  RESET_PROJECT,
  SET_ARCHITECTURE,
  SET_ORGANIZATION_UUID,
  SET_PIXEL_KEYS,
  SET_PROJECT,
  SET_PROJECT_UUID,
  SET_STRIPE_CLIENT_ACCOUNT,
  SET_STRIPE_CONNECT_ID,
  SET_STRIPE_KEY,
} from "../actions/ActionTypes";

import type { ArchitectureState } from "./architecture.types";
import type { ArchitectureActions } from "../actions/architecture.types";

const initialState: ArchitectureState = {
  architecture: {},
  project_uuid: "",
  organization_uuid: "",
  project: undefined,
  pixel_keys: {
    ga_key: "",
    fb_key: "",
  },
};

const architectureReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: ArchitectureActions,
): ArchitectureState => {
  switch (action.type) {
    case SET_ARCHITECTURE:
      return {
        ...state,
        architecture: action.architecture ?? {},
      };
    case RESET_ARCHITECTURE:
      return {
        ...state,
        architecture: action.params ?? {},
      };
    case SET_PROJECT_UUID:
      return {
        ...state,
        project_uuid: action.uuid ?? initialState.project_uuid,
      };
    case SET_ORGANIZATION_UUID:
      return {
        ...state,
        organization_uuid: action.uuid ?? initialState.organization_uuid,
      };
    case SET_PROJECT:
      return {
        ...state,
        project: action.project ?? initialState.project,
      };
    case SET_STRIPE_KEY:
      return {
        ...state,
        stripe_key: action.key ?? initialState.stripe_key,
      };
    case SET_STRIPE_CLIENT_ACCOUNT:
      return {
        ...state,
        stripe_client_account: action.key ?? initialState.stripe_client_account,
      };
    case SET_STRIPE_CONNECT_ID:
      return {
        ...state,
        stripe_client_id: action.client_id ?? initialState.stripe_client_id,
      };
    case SET_PIXEL_KEYS:
      return {
        ...state,
        pixel_keys: action.keys ?? initialState.pixel_keys,
      };
    case RESET_PROJECT:
      return {
        ...state,
        project_uuid: initialState.project_uuid,
        project: initialState.project,
      };
    default:
      return state;
  }
};

export default architectureReducer;
